import Grid from '@mui/material/Grid';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { FormSelect } from '../../../components/hook-form/form-select.component';
import { FormDateField } from '../../../components/hook-form/form-date.field.component';

export const EquipmentForm = () => {
  const options = [
    {
      value: 'active',
      label: 'Active',
      isDefault: true,
    },
    {
      value: 'inactive',
      label: 'Inactive',
      isDefault: false,
    },
  ];
  return (
    <Grid container spacing={2}>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Equipment Name" name="equipmentName" maxLength={150} multiline={false} autoFocus />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Note" name="notes" maxLength={150} multiline={true} />
      </Grid>
      <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormInput label="Brand" name="brand" />
      </Grid>
      <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormInput label="Model Number" name="modelNumber" />
      </Grid>
      <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormInput label="Serial Number" name="serialNumber" />
      </Grid>
      <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormInput type='number' label="Warranty (in months)" name="warantyPeriod" />
      </Grid>
      <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormDateField label="Purchased On" name="purchasedOn" />
      </Grid>
      <Grid item lg={6} sm={6} xl={6} xs={6}>
        <FormSelect label="Status" name="status" options={options} />
      </Grid>
    </Grid>
  );
};
